import React from "react";

interface FormSectionProps {
  number: number;
  title: string;
  description: string;
  children: React.ReactNode;
}

export function FormSection({ number, title, description, children }: FormSectionProps) {
  return (
    <div className="space-y-2.5">
      <div className="flex items-center gap-2.5">
        <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 text-primary text-xs font-medium flex items-center justify-center">
          {number}
        </span>
        <h3 className="text-sm font-medium text-foreground">{title}</h3>
        {description && <span className="text-xs text-muted-foreground">{description}</span>}
      </div>
      <div className="pl-[34px]">{children}</div>
    </div>
  );
}
